"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = require("vue");

var _util = require("./util");

var itemProps = {
  title: String,
  field: String,
  span: [String, Number],
  align: String,
  titleAlign: String,
  titleWidth: [String, Number],
  className: [String, Function],
  titleOverflow: {
    type: [Boolean, String],
    default: null
  },
  titlePrefix: Object,
  titleSuffix: Object,
  resetValue: {
    default: null
  },
  visibleMethod: Function,
  visible: {
    type: Boolean,
    default: null
  },
  folding: Boolean,
  collapseNode: Boolean,
  itemRender: Object
};

var _default = (0, _vue.defineComponent)({
  name: 'VxeFormItem',
  props: itemProps,
  setup: function setup(props, _ref) {
    var slots = _ref.slots;
    var refElem = (0, _vue.ref)();
    var $xeform = (0, _vue.inject)('$xeform', {});
    var formItem = (0, _util.createItem)($xeform, props);
    formItem.slots = slots;
    (0, _util.watchItem)(props, formItem);
    (0, _vue.nextTick)(function () {
      (0, _util.assemItem)($xeform, refElem.value, formItem);
    });
    (0, _vue.onUnmounted)(function () {
      (0, _util.destroyItem)($xeform, formItem);
    });

    var renderVN = function renderVN() {
      return (0, _vue.h)('div', {
        ref: refElem
      });
    };

    return renderVN;
  }
});

exports.default = _default;